<template>
  <div>
    <div v-if="className == 'mk-subject-block-top'" class="mk-subject-block-top">
      <div class="mk-subject-title">{{ element.titleBarName }}</div>
      <div class="mk-subject-summary">{{ element.titleBarDesc }}</div>
      <div class="swiper mk-subject-block-top-swiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in childItem.propsValue.data.slice(0, 4)"
            :key="index"
          >
            <div class="mk-subject-block-title">{{ item.customField2 }}</div>
            <div class="mk-subject-block-summary">
              {{ item.customField3 }}
              <span>{{ item.customField4.text }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="className == 'mk-subject-block-bottom'" class="mk-subject-block-bottom">
      <div class="mk-subject-title">{{ element.titleBarName }}</div>
      <div class="mk-subject-summary">{{ element.titleBarDesc }}</div>
      <div class="swiper mk-subject-block-bottom-swiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in childItem.propsValue.data.slice(0, 3)"
            :key="index"
          >
            <div class="mk-subject-block-title">{{ item.customField2 }}</div>
            <div class="mk-subject-block-summary">{{ item.customField3 }}</div>
            <div class="mk-subject-block-jiantou">{{ item.customField4.text }}</div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="className == 'mk-subject-apply'" class="mk-subject-apply">
      <div class="mk-subject-title">{{ element.titleBarName }}</div>
      <div class="mk-subject-summary">{{ element.titleBarDesc }}</div>
      <div class="mk-subject-apply-list">
        <div class="swiper mk-subject-apply-swiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in childItem.propsValue.data.slice(0, 6)"
              :key="index"
              :style="{
                backgroundImage: 'url(' + item.customField1 + ')',
                backgroundSize: '100% 100%',
              }"
            >
              <div class="mk-subject-apply-title">{{ item.customField2 }}</div>
              <div class="mk-subject-apply-summary">{{ item.customField3 }}</div>
              <div class="mk-subject-apply-detail">{{ item.customField4.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { buttonObject } from "@/modules/autoweb/config/elementObject.js";
let buttonObjectTemp = _.cloneDeep(buttonObject);
buttonObjectTemp.text = "→";
export default {
  name: "MkImageBlockPhone",
  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      }
    },
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    className() {
      let selectClass = _.filter(this.element.class, item => item.selected)[0];
      return selectClass.value;
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "背景",
          type: "image",
          width: 155,
          height: 70
        },
        {
          code: "customField2",
          label: "标题",
          type: "text"
        },
        {
          code: "customField3",
          label: "介绍",
          type: "text"
        },
        {
          code: "customField4",
          label: "按钮",
          type: "button"
        }
      ],
      data: [
        {
          customField1:
            "https://mks.yybip.com/group1/M00/0B/60/CgoRC2iHPN2AYGu8AAAkhzP8IuE433.png",
          customField2: "营销干活",
          customField3: "你需要的干货都在这",
          customField4: _.cloneDeep(buttonObjectTemp)
        },
        {
          customField1:
            "https://mks.yybip.com/group1/M00/0B/60/CgoRC2iHPN2AYGu8AAAkhzP8IuE433.png",
          customField2: "营销干活",
          customField3: "你需要的干货都在这",
          customField4: _.cloneDeep(buttonObjectTemp)
        },
        {
          customField1:
            "https://mks.yybip.com/group1/M00/0B/60/CgoRC2iHPN2AYGu8AAAkhzP8IuE433.png",
          customField2: "营销干活",
          customField3: "你需要的干货都在这",
          customField4: _.cloneDeep(buttonObjectTemp)
        },
        {
          customField1:
            "https://mks.yybip.com/group1/M00/0B/60/CgoRC2iHPN2AYGu8AAAkhzP8IuE433.png",
          customField2: "营销干活",
          customField3: "你需要的干货都在这",
          customField4: _.cloneDeep(buttonObjectTemp)
        },
        {
          customField1:
            "https://mks.yybip.com/group1/M00/0B/60/CgoRC2iHPN2AYGu8AAAkhzP8IuE433.png",
          customField2: "营销干活",
          customField3: "你需要的干货都在这",
          customField4: _.cloneDeep(buttonObjectTemp)
        },
        {
          customField1:
            "https://mks.yybip.com/group1/M00/0B/60/CgoRC2iHPN2AYGu8AAAkhzP8IuE433.png",
          customField2: "营销干活",
          customField3: "你需要的干货都在这",
          customField4: _.cloneDeep(buttonObjectTemp)
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.mk-subject-block-top {
  padding: 0.4rem 0.6rem;
  background-color: #fff;
  .mk-subject-title {
    font-family: AlibabaPuHuiTi_3_85_Bold;
    font-size: 0.33rem;
    color: #e60012;
    line-height: 0.39rem;
    text-align: center;
    font-weight: bold;
    margin-bottom: 0.15rem;
  }
  .mk-subject-summary {
    font-family: AlibabaPuHuiTi_3_55_Regular;
    font-size: 0.24rem;
    color: #717071;
    line-height: 0.42rem;
    text-align: center;
    margin-bottom: 0.44rem;
  }
  .mk-subject-block-top-swiper {
    width: 100%;
    padding-bottom: 0.36rem;
    .swiper-wrapper {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .swiper-slide {
        margin-bottom: 0.4rem;
        width: 3.1rem;
        height: 1.4rem;
        border: 1px solid #ccc;
        border-radius: 0.1rem;
        box-sizing: border-box;
        padding: 0.3rem 0.1rem;
      }
      .swiper-slide:nth-child(1),
      .swiper-slide:nth-child(3) {
        margin-right: 0.1rem;
      }
    }
  }
  .mk-subject-block-title {
    font-family: AlibabaPuHuiTi_3_65_Medium;
    font-size: 0.28rem;
    color: #515051;
    line-height: 0.36rem;
    text-transform: none;
    margin-bottom: 0.1rem;
  }
  .mk-subject-block-summary {
    font-family: AlibabaPuHuiTi_3_55_Regular;
    font-size: 0.25rem;
    color: #717071;
    line-height: 0.36rem;
    span {
      margin-left: 0.1rem;
    }
  }
}

.mk-subject-block-bottom {
  padding: 0rem 0.48rem 0.4rem;
  .mk-subject-title {
    font-family: AlibabaPuHuiTi_3_85_Bold;
    font-size: 0.33rem;
    color: #e60012;
    line-height: 0.39rem;
    text-align: center;
    font-weight: bold;
    margin-bottom: 0.15rem;
  }
  .mk-subject-summary {
    font-family: AlibabaPuHuiTi_3_55_Regular;
    font-size: 0.24rem;
    color: #717071;
    line-height: 0.42rem;
    text-align: center;
    margin-bottom: 0.44rem;
  }
  .mk-subject-block-bottom-swiper {
    padding: 0.36rem 0;
    .swiper-wrapper {
      width: 100%;
      display: flex;
      flex-wrap: nowrap;
      .swiper-slide {
        width: 2.4rem;
        height: 1.9rem;
        border-radius: 0.14rem;
        box-sizing: border-box;
        background-color: #ccc;
        padding: 0.3rem 0.3rem 0.3rem 0.2rem;
        position: relative;
      }
      .swiper-slide:nth-child(1),
      .swiper-slide:nth-child(2) {
        margin-right: 0.1rem;
      }
    }
  }
  .mk-subject-block-title {
    font-family: AlibabaPuHuiTi_3_65_Medium;
    font-size: 0.28rem;
    color: #515051;
    line-height: 0.36rem;
    text-transform: none;
    margin-bottom: 0.1rem;
  }
  .mk-subject-block-summary {
    font-family: AlibabaPuHuiTi_3_55_Regular;
    font-size: 0.25rem;
    color: #717071;
    line-height: 0.36rem;
  }
  .mk-subject-block-jiantou {
    font-size: 0.17rem;
    color: #e60012;
    text-align: right;
    margin-right: -0.12rem;
  }
}

.mk-subject-apply {
  padding: 0.56rem 0.42rem 0.4rem;
  background-color: #fafafa;
  text-align: center;
  .mk-subject-title {
    font-family: AlibabaPuHuiTi_3_85_Bold;
    font-size: 0.33rem;
    color: #e60012;
    line-height: 0.39rem;
    text-align: center;
    font-weight: bold;
    margin-bottom: 0.15rem;
  }
  .mk-subject-summary {
    font-family: AlibabaPuHuiTi_3_55_Regular;
    font-size: 0.24rem;
    color: #717071;
    line-height: 0.42rem;
    text-align: center;
    margin-bottom: 0.44rem;
  }
  .mk-subject-apply-list {
    position: relative;
    padding: 0 0.3rem;
    padding-bottom: 0.4rem;
  }
  .mk-subject-apply-swiper {
    .swiper-wrapper {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .swiper-slide {
        width: 140px;
        height: auto;
        background-color: #ccc;
        border-radius: 0.14rem;
        padding: 0.56rem 0.4rem 0.21rem 0;
        box-sizing: border-box;
        margin-bottom: 0.2rem;
      }
      .swiper-slide:nth-child(1),
      .swiper-slide:nth-child(3),
      .swiper-slide:nth-child(5) {
        margin-right: 0.2rem;
      }
    }
  }

  .swiper-button-next {
    right: -0.28rem;
    font-size: 0.34rem;
    color: #717071;
    opacity: 0.5;
  }
  .swiper-button-prev {
    left: -0.28rem;
    font-size: 0.34rem;
    color: #717071;
    opacity: 0.5;
  }
  .swiper-button-next:after,
  .swiper-button-prev:after {
    font-size: 0.34rem;
  }
  .mk-subject-apply-title {
    padding-left: 0.23rem;
    border-left: 0.03rem solid #e60012;
    font-family: AlibabaPuHuiTi_3_65_Medium;
    font-size: 0.26rem;
    color: #515051;
    line-height: 0.35rem;
    text-align: left;
    margin-bottom: 0.1rem;
  }
  .mk-subject-apply-summary {
    padding-left: 0.21rem;
    font-family: AlibabaPuHuiTi_3_65_Medium;
    font-size: 0.21rem;
    color: #919091;
    line-height: 0.28rem;
    text-align: left;
    margin-bottom: 0.1rem;
  }
  .mk-subject-apply-detail {
    padding-left: 0.21rem;
    font-family: AlibabaPuHuiTi_3_55_Regular;
    font-size: 0.21rem;
    color: #919091;
    line-height: 0.28rem;
    text-align: left;
  }
}
</style>